export default {
  data: () => ({
    translations: {
      title: {
        el: '',
        en: 'Customers Base',
        it: '',
      },
      all: {
        el: 'Όλοι',
        en: 'All',
        it: 'Tutto',
      },
      stores: {
        el: 'Καταστήματα',
        en: 'Stores',
        it: 'I negozi',
      },
      receiveNews: {
        el: 'Επιθυμώ να λαμβάνω νέα και προσφορές απο την εταιρία',
        en: 'Receive news and offers from the company',
        it: "Desidero ricevere notizie e offerte dall'azienda",
      },
      selectOneOrMore: {
        el: 'Επιλέξτε ένα ή περισσότερα μέσα ενημέρωσης του πελάτη',
        en: 'Select one or more means to inform the customer',
        it: 'Seleziona uno o più mezzi per informare il cliente',
      },
      info: {
        el: 'Εδώ έχετε τη λίστα των πελατών σας που συλλέγονται από όλες τις διαφορετικές πηγές, όπως εφαρμογές για κινητά, συσκευές POS, κάρτες πιστότητας κ.λπ. Προσθέστε νέους πελάτες χειροκίνητα ή εισάγετε φίλτρα για τους πελάτες σας.',
        en: `
                    Here you got the list of your customers collected from all different 
                    sources like mobile apps, POS devices, loyalty cards etc. Add new customers 
                    manually or insert filters for your customers.
                `,
        it: 'Qui hai la tua lista di clienti raccolta da tutte le diverse fonti, come le app mobili, i dispositivi POS, le carte fedeltà, ecc. Aggiungi nuovi clienti manualmente o inserisci dei filtri per i tuoi clienti.',
      },
      addNewCustomer: {
        el: 'Προσθήκη Νέου Πελάτη',
        en: 'Add New Customer',
        it: 'Aggiungi nuovo cliente',
      },
      customer: {
        el: 'Κωδικός Πελάτη',
        en: 'Customer ID',
        it: 'Identificativo Del Cliente',
      },
      user_account_id: {
        el: 'Κωδικός Πελάτη',
        en: 'Customer ID',
        it: 'Identificativo Del Cliente',
      },
      totalPrice: {
        el: 'Συνολική Τιμή',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      total_price: {
        el: 'Συνολική Τιμή',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      transactions: {
        el: 'Συναλλαγές',
        en: 'Transactions',
        it: 'Transazione',
      },
      user_id: {
        el: 'ID χρήστη',
        en: 'user ID',
        it: 'user ID',
      },
      first_name: {
        el: 'Όνομα',
        en: 'First Name',
        it: 'Nome',
      },
      last_name: {
        el: 'Επώνυμο',
        en: 'Last Name',
        it: 'Cognome',
      },
      total_transactions: {
        el: 'Συναλλαγές',
        en: 'Transactions',
        it: 'Transazione',
      },
      total_points: {
        el: 'Σύνολο Πόντων',
        en: 'Total Points',
        it: 'Punti Totali',
      },
      total_cashback: {
        el: 'Σύνολο Cashback',
        en: 'Total Cashback',
        it: 'Rimborso Totale',
      },
      redeemed_points: {
        el: 'Εξαργυρωμένοι Πόντοι',
        en: 'Redeemed Points',
        it: 'Punti Riscattati',
      },
      redeemed_cashback: {
        el: 'Εξαργυρωμένο Cashback',
        en: 'Redeemed Cashback',
        it: 'Rimborso Riscattato',
      },
      available_points: {
        el: 'Διαθέσιμοι Πόντοι',
        en: 'Available Points',
        it: 'Punti Disponibili',
      },
      available_cashback: {
        el: 'Διαθέσιμο Cashback',
        en: 'Available Cashback',
        it: 'Rimborso Disponibile',
      },
      current_balance_points: {
        el: 'Διαθέσιμοι Πόντοι',
        en: 'Available Points',
        it: 'Punti Disponibili',
      },
      current_balance_cashback: {
        el: 'Διαθέσιμο Cashback',
        en: 'Available Cashback',
        it: 'Rimborso Disponibile',
      },
      userTab: {
        el: '',
        en: 'User Tab',
        it: '',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'Aggiornamento',
      },
      updateCustomer: {
        el: 'Ενημέρωση Στοιχείων Πελάτη',
        en: 'Update Customer Details',
        it: 'Aggiorna i Dettagli del Cliente',
      },
      customerDetails: {
        el: 'Στοιχεία Πελάτη',
        en: 'Customer Details',
        it: 'Dettagli del Cliente',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancella',
      },
      additionalInfo: {
        el: '',
        en: 'Additional Info',
        it: '',
      },
      firstName: {
        el: 'Όνομα',
        en: 'First Name',
        it: 'Nome',
      },
      lastName: {
        el: 'Επώνυμο',
        en: 'Last Name',
        it: 'Cognome',
      },
      cardNumbers: {
        el: 'Αριθμοί Καρτών',
        en: 'Card Numbers',
        it: 'Numeri di carta',
      },
      address: {
        el: 'Διεύθυνση',
        en: 'Address',
        it: 'Indirizzo',
      },
      gender: {
        el: 'Φύλο',
        en: 'Gender',
        it: 'Sesso',
      },
      birthDate: {
        el: 'Ημερομηνία Γέννησης',
        en: 'Date of Birth',
        it: 'Data di nascita',
      },
      selectAll: {
        el: 'Επιλογή Όλων',
        en: 'Select All',
        it: 'Selezione di Tutti',
      },
      deselectAll: {
        el: 'Αποεπιλογή Όλων',
        en: 'Deselect All',
        it: 'Chiedete Scusa a Tutti',
      },
      cardNumber: {
        el: 'Αριθμός Κάρτας',
        en: 'Card Number',
        it: 'Numero di carta',
      },
      card_number: {
        el: 'Αριθμός Κάρτας',
        en: 'Card Number',
        it: 'Numero di carta',
      },
      email: {
        el: 'Email',
        en: 'Email',
        it: 'Email',
      },
      mobile: {
        el: 'Κινητό',
        en: 'Mobile',
        it: 'Cellulare',
      },
      form_date: {
        el: 'Ημερομηνία',
        en: 'Form Date',
        it: 'Data',
      },
      store: {
        el: 'Κατάστημα',
        en: 'Store',
        it: 'Negozio',
      },
      cc: {
        el: 'Χώρα',
        en: 'Country Code',
        it: 'Nazione',
      },
      landlinePhone: {
        el: 'Σταθερό Τηλέφωνο',
        en: 'Landline Number',
        it: 'Telefono fisso',
      },
      postCode: {
        el: 'Τ.Κ',
        en: 'Postcode',
        it: 'Codice Postale',
      },
      country: {
        el: 'Νομός',
        en: 'State',
        it: 'Provincia',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      cardNumbersActivated: {
        el: 'Ενεργοποιημένες κάρτες',
        en: 'Activated cards',
        it: 'Carte attivate',
      },
      store_points: {
        el: 'Πόντοι καταστήματος',
        en: 'Store points',
        it: 'Punti vendita',
      },
      store_cashback: {
        el: 'Cashback καταστήματος',
        en: 'Store cashback',
        it: 'Cashback vendita',
      },
      merge: {
        el: 'Συγχώνευση',
        en: 'Merge',
        it: 'Unire',
      },
      mergeSuccess: {
        el: 'Επιτυχής συγχώνευση',
        en: 'Merged successfuly',
        it: 'Fusione riuscita',
      },
      mergeUserId: {
        el: 'Συγχώνευση του χρήστη με κινητό',
        en: 'Merge',
        it: 'Unire',
      },
      phone: {
        el: 'Τηλέφωνο',
        en: 'Mobile phone',
        it: 'Telefono',
      },
      absorb: {
        el: ' που θα συγχωνευτεί',
        en: ' to absorb',
        it: ' assorbire',
      },
      keep: {
        el: ' που θα διατηρηθεί',
        en: ' to keep',
        it: ' mantenere',
      },
      into: {
        el: 'στον χρήστη με κινητό',
        en: 'into',
        it: 'in',
      },
      mergeProcess24h: {
        el: 'Η διαδικασία συγχώνευσης μπορεί να διαρκέσει εώς και 24 ώρες.',
        en: 'The merging process can last up to 24 hours.',
        it: 'Il processo di fusione può durare fino a 24 ore.',
      },
      addCard: {
        el: 'Προσθήκη Κάρτας',
        en: 'Add Card',
        it: 'Aggiungi Carta',
      },
      visibleColumns: {
        el: 'Ορατές Στήλες',
        en: 'Visible Columns',
        it: 'Colonne Visibili',
      },
      formDate: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Date',
      },
      changeMobile: {
        el: 'Αλλαγή αριθμού κινητού τηλεφώνου',
        en: 'Change Mobile Phone Number',
        it: 'Modifica del numero di cellulare',
      },
      save: {
        el: 'Αποθήκευση',
        en: 'Save',
        it: 'Salva',
      },
      cancel: {
        el: 'Ακύρωση',
        en: 'Cancel',
        it: 'Cancella',
      },
      clear_points: {
        el: 'Αφαίρεση Όλων των Πόντων Πελάτη',
        en: 'Remove All Customer Points',
        it: 'Rimuovi Tutti i Punti Cliente',
      },
      clear_pointsConfirmation1: {
        el: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε όλους τους πόντους για τον πελάτη:',
        en: 'Are you sure you want to remove all the points for customer:',
        it: 'Sei sicuro di voler rimuovere tutti i punti per il cliente:',
      },
      clear_cashback: {
        el: 'Αφαίρεση Όλου του Cashback Πελάτη',
        en: 'Remove All Customer Cashback',
        it: 'Rimuovi Tutti i cashback Cliente',
      },
      clear_cashbackConfirmation1: {
        el: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε όλους τους πόντους για τον πελάτη:',
        en: 'Are you sure you want to remove all the points for customer:',
        it: 'Sei sicuro di voler rimuovere tutti i punti per il cliente:',
      },
      detachCard: {
        el: 'Αποσύνδεση κάρτας πελάτη',
        en: 'Detach Customer Card',
        it: 'Staccare la scheda cliente',
      },

      submit: {
        el: 'Υποβολή',
        en: 'Submit',
        it: 'Invia',
      },

      detachCardConfirmation1: {
        el: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε την κάρτα για τον πελάτη με στοιχεία:',
        en: 'Are you sure you want to remove the card for customer:',
        it: 'È sicuro di voler rimuovere la scheda per il cliente:',
      },

      importCustomers: {
        el: 'Εισαγωγή πελατών',
        en: 'Import Customers',
        it: 'Importazione di clienti',
      },

      importCustomersDescription: {
        el: 'Επιλέξτε το αρχείο CSV που περιέχει τους πελάτες που θέλετε να εισαγάγετε.',
        en: 'Select the CSV file containing the customers you wish to import.',
        it: 'Selezionare il file CSV contenente i clienti che si desidera importare.',
      },

      moreActions: {
        el: 'Περισσότερες ενέργειες',
        en: 'More Actions',
        it: 'Altre azioni',
      },
      attributes: {
        el: 'Ιδιότητες',
        en: 'Attributes',
        it: 'Attributi',
      },

      customAttributes: {
        el: 'Προσαρμοσμένες Ιδιότητες',
        en: 'Custom Attributes',
        it: 'Attributi personalizzati',
      },
      type: {
        el: 'Τύπος',
        en: 'Type',
        it: 'Tipo',
      },
      input: {
        el: 'Πεδίο',
        en: 'Input',
        it: 'Ingresso',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      options: {
        el: 'Επιλογές',
        en: 'Options',
        it: 'Opzioni',
      },
      for: {
        el: 'για',
        en: 'for',
        it: 'per',
      },
      option: {
        el: 'Επιλογή',
        en: 'Option',
        it: 'Opzione',
      },
      createNewAttribute: {
        el: 'Δημιουργία Νέας Ιδιότητας',
        en: 'Create New Attribute',
        it: 'Creare un nuovo attributo',
      },
      editAttribute: {
        el: 'Επεξεργασία Ιδιότητας',
        en: 'Edit Attribute',
        it: 'Modifica attributo',
      },
      deleteAttribute: {
        el: 'Διαγραφή Ιδιότητας',
        en: 'Delete Attribute',
        it: 'Cancella attributo',
      },

      addNewOption: {
        el: 'Προσθήκη νέας επιλογής',
        en: 'Add New Option',
        it: 'Aggiungi nuova opzione',
      },

      createAttributeSuccess: {
        el: 'Η ιδιότητα δημιουργήθηκε επιτυχώς',
        en: 'Attribute was created successully',
        it: "L'attributo è stato creato con successo",
      },
      updateAttributeSuccess: {
        el: 'Η ιδιότητα ενημερώθηκε επιτυχώς',
        en: 'Attribute was updated successully',
        it: "L'attributo è stato aggiornato con successo",
      },
      deleteAttributeSuccess: {
        el: 'Η ιδιότητα διαγράφηκε επιτυχώς',
        en: 'Attribute was deleted successully',
        it: "L'attributo è stato cancellato con successo",
      },
      deleteAttributeConfirmation1: {
        el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ιδιότητα με στοιχεία:',
        en: 'Are you sure you want to delete the following attribute:',
        it: 'Si è sicuri di voler eliminare il seguente attributo :',
      },
      attributeSaveNoValue: {
        el: 'Παρακαλώ εισάγετε μια τιμή πριν αποθηκεύσετε ή διαγράψτε την ιδιότητα.',
        en: 'Please enter a value before saving or delete the attribute instead.',
        it: "Inserisci un valore prima di salvare o elimina l'attributo.",
      },
      deleteAttributeConfirmation: {
        el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ιδιότητα με τιμή(ες):',
        en: 'Are you sure you want to delete the attribute with value(s):',
        it: "Sei sicuro di voler eliminare l'attributo con valore(i):",
      },
      deletePermanently: {
        el: 'Οριστική διαγραφή',
        en: 'Delete permanently',
        it: 'Cancellare definitivamente',
      },
      deleteCustomer: {
        el: 'Οριστική διαγραφή πελάτη',
        en: 'Delete customer',
        it: 'Cancellare cliente',
      },
      deleteCustomerSuccess: {
        el: 'Ο/Η χρήστης διαγράφηκε επιτυχώς',
        en: 'The customer was deleted successully',
        it: 'Il cliente è stato cancellato con successo',
      },
      deleteCustomerConfirmation1: {
        el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον χρήστη με στοιχεία:',
        en: 'Are you sure you want to delete the following customer:',
        it: 'Si è sicuri di voler eliminare il seguente cliente :',
      },
      number: {
        el: 'Αριθμός',
        en: 'Number',
        it: 'Numero',
      },
      text: {
        el: 'Κείμενο',
        en: 'Text',
        it: 'Testo',
      },

      invalidValue: {
        el: 'Μη έγκυρη τιμή: Παρακαλώ, πληκτρολογήστε έναν αριθμό',
        en: 'Invalid value: Please, type a number',
        it: 'Valore non valido: Digitare un numero',
      },
      notifications: {
        el: 'Ειδοποιήσεις',
        en: 'Notifications',
        it: 'Notifiche',
      },
      campaign_title: {
        el: 'Τίτλος Καμπάνιας',
        en: 'Campaign Title',
        it: 'Titolo della campagna',
      },
      system_notification_type: {
        el: 'Τυπος ειδοποίησης',
        en: ' Notification Type',
        it: 'Notifica di sistema',
      },
      notification_category_system: {
        el: 'Κατηγορία ειδοποιήσεων',
        en: 'Not. Category',
        it: 'Categoria di notifica',
      },
      system_notification_type_filter: {
        el: 'Φιλτράρισμα ανά τύπο ειδοποίησης',
        en: 'Filter By Notification Type',
        it: 'Filtra per tipo di notifica',
      },
      notification_category_system_filter: {
        el: 'Φιλτράρισμα ανά κατηγορία',
        en: 'Filter by Category',
        it: 'Filtra per categoria',
      },
      system_notification_type_select: {
        el: 'Επιλέξτε τύπους ειδοποίησης',
        en: 'Select one or more types',
        it: 'Seleziona uno o più tipi',
      },
      notification_category_system_select: {
        el: 'Επιλέξτε κατηγορίες ειδοποίησης',
        en: 'Select one or more categories',
        it: 'Seleziona una o più categorie',
      },
      date_filter: {
        el: 'Φιλτράρισμα ανά Ημερομηνία',
        en: 'Filter by Date',
        it: 'Filtra per data',
      },
      from_date: {
        el: 'Από Ημερομηνία',
        en: 'From Date',
        it: 'Da Data',
      },
      to_date: {
        el: 'Μέχρι Ημερομηνία',
        en: 'To Date',
        it: 'Ad oggi',
      },
      from: {
        el: 'Από',
        en: 'From',
        it: 'Da',
      },
      to: {
        el: 'Μέχρι',
        en: 'To',
        it: 'A',
      },
      body_full: {
        el: 'Δείξε όλο το κείμενο',
        en: 'Show full text',
        it: 'Mostra il testo completo',
      },
      show_details: {
        el: 'Εμφάνιση λεπτομερειών',
        en: 'Show details',
        it: 'Mostra dettagli',
      },
      body: {
        el: 'Σώμα',
        en: 'Body',
        it: 'Corpo',
      },
      identifier: {
        el: 'Αναγνωριστικό',
        en: 'Identifier',
        it: 'Identificatore',
      },
      data: {
        el: 'Δεδομένα',
        en: 'Data',
        it: 'Dati',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      created: {
        el: 'Δημιουργήθηκε',
        en: 'Created',
        it: 'Creato',
      },
      mobileRequiredError: {
        el: 'Το κινητό είναι υποχρεωτικό.',
        en: 'Mobile is required.',
        it: 'Il cellulare è obbligatorio.',
      },
      mobileDigitsError: {
        el: 'Το κινητό πρέπει να περιέχει μόνο ψηφία.',
        en: 'Mobile must contain only digits.',
        it: 'Il cellulare deve contenere solo cifre.',
      },
      mobileLengthError: {
        el: 'Το κινητό χρήστη πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.',
        en: 'User Mobile must be between 7 and 12 characters long',
        it: "Il cellulare dell'utente deve avere una lunghezza compresa tra 7 e 12 caratteri.",
      },
      storePointTitle: {
        el: 'Βαθμίδα',
        en: 'Current Tier',
        it: 'Livello Attuale',
      },
      customers: {
        el: 'Πελάτες',
        en: 'Customers',
        it: 'Clienti',
      },
      child_id: {
        el: 'Κατάστημα (Child)',
        en: 'Store (Child)',
        it: 'Negozio (Child)',
      },
      first_transaction_store_id: {
        el: 'Κατάστημα Πρώτης Συναλλαγής',
        en: 'First Transaction Store',
        it: 'Negozio Prima Transazione',
      },
      registration_store_id: {
        el: 'Κατάστημα Εγγραφής',
        en: 'Registration Store',
        it: 'Negozio Registrazione',
      },
      sms: {
        el: 'SMS',
        en: 'SMS',
        it: 'SMS',
      },
      viber: {
        el: 'Viber',
        en: 'Viber',
        it: 'Viber',
      },
      push: {
        el: 'Push',
        en: 'Push',
        it: 'Push',
      },
      mail: {
        el: 'Mail',
        en: 'Mail',
        it: 'Mail',
      },
      marketing: {
        el: 'Marketing',
        en: 'Marketing',
        it: 'Marketing',
      },
      clear: {
        el: 'Καθαρισμός',
        en: 'Clear',
        it: 'Cancella',
      },
      clearAll: {
        el: 'Καθαρισμoς',
        en: 'Clear All',
        it: 'Cancella Tutto',
      },
      moreFilters: {
        el: 'Περισσότερα Φίλτρα',
        en: 'More Filters',
        it: 'Altri Filtri',
      },
      advancedFilters: {
        el: 'Περισσότερα Φίλτρα',
        en: 'Advanced Filters',
        it: 'Filtri Avanzati',
      },
      notSelected: {
        el: 'Χωρίς επιλογή',
        en: 'Not selected',
        it: 'Non selezionato',
      },
      country_id: {
        el: 'Χώρα',
        en: 'Country',
        it: 'Nazione',
      },
      close: {
        el: 'Κλείσιμο',
        en: 'Close',
        it: 'Chiudi',
      },
      yes: {
        el: 'Ναι',
        en: 'Yes',
        it: 'Sì',
      },
      no: {
        el: 'Όχι',
        en: 'No',
        it: 'No',
      },
      minimum_age: {
        el: 'Ελάχιστη ηλικία',
        en: 'Minimum Age',
        it: 'Età minima',
      },
      maximum_age: {
        el: 'Μέγιστη ηλικία',
        en: 'Maximum Age',
        it: 'Età massima',
      },
      male: {
        el: 'Άνδρας',
        en: 'Male',
        it: 'Maschio',
      },
      female: {
        el: 'Γυναίκα',
        en: 'Female',
        it: 'Femmina',
      },
      other: {
        el: 'Άλλο',
        en: 'Other',
        it: 'Altro',
      },
      county_id: {
        el: 'Νομός',
        en: 'County',
        it: 'Provincia',
      },
      birth_date: {
        el: 'Ημερομηνία Γέννησης',
        en: 'Birth Date',
        it: 'Data di nascita',
      },
      minimum_total_transactions: {
        el: 'Ελάχιστες συναλλαγές',
        en: 'Minimum Transactions',
        it: 'Transazioni minime',
      },
      maximum_total_transactions: {
        el: 'Μέγιστες συναλλαγές',
        en: 'Maximum Transactions',
        it: 'Transazioni massime',
      },
      minimum_total_redemptions: {
        el: 'Ελάχιστες εξαργυρώσεις',
        en: 'Minimum Redemptions',
        it: 'Redenzioni minime',
      },
      maximum_total_redemptions: {
        el: 'Μέγιστες εξαργυρώσεις',
        en: 'Maximum Redemptions',
        it: 'Redenzioni massime',
      },
      minimum_total_amount: {
        el: 'Ελάχιστο ποσό',
        en: 'Minimum Amount',
        it: 'Importo minimo',
      },
      maximum_total_amount: {
        el: 'Μέγιστο ποσό',
        en: 'Maximum Amount',
        it: 'Importo massimo',
      },
      minimum_current_balance: {
        el: 'Ελάχιστο υπόλοιπο',
        en: 'Minimum Balance',
        it: 'Saldo minimo',
      },
      maximum_current_balance: {
        el: 'Μέγιστο υπόλοιπο',
        en: 'Maximum Balance',
        it: 'Saldo massimo',
      },
      reference: { el: 'Αναφορά', en: 'Reference', it: 'Riferimento' },
      minimum: { el: 'Ελάχιστο', en: 'Min', it: 'Minimo' },
      maximum: { el: 'Μέγιστο', en: 'Max', it: 'Massimo' },
      total_redemptions: {
        el: 'Εξαργυρώσεις',
        en: 'Redemptions',
        it: 'Redenzioni',
      },
      total_amount: { el: 'Ποσό', en: 'Amount', it: 'Importo' },
      filtersTitle: { el: 'Φίλτρα', en: 'Filters', it: 'Filtri' },
      adjust_pointsTooltip: {
        el: 'Προσθήκη / Αφαίρεση Πόντων',
        en: 'Add / Remove Points',
        it: 'Aggiungi / Rimuovi Punti',
      },
      adjust_cashbackTooltip: {
        el: 'Προσθήκη / Αφαίρεση Cashback',
        en: 'Add / Remove Cashback',
        it: 'Aggiungi / Rimuovi Rimborso',
      },
      adjust_pointsDialogTitle: {
        el: 'Προσαρμογή Πόντων',
        en: 'Adjust Points',
        it: 'Regola Punti',
      },
      adjust_cashbackDialogTitle: {
        el: 'Προσαρμογή Cashback',
        en: 'Adjust Cashback',
        it: 'Regola Rimborso',
      },
      pointsAmount: {
        el: 'Ποσότητα Πόντων',
        en: 'Points Amount',
        it: 'Quantità di Punti',
      },
      cashbackAmount: {
        el: 'Ποσότητα Cashback',
        en: 'Cashback Amount',
        it: 'Quantità di Rimborso',
      },
      loyaltyProgram: {
        el: 'Πρόγραμμα επιβράβευσης',
        en: 'Loyalty Program',
        it: 'Programma fedeltà',
      },
      reason: {
        el: 'Αιτιολογία',
        en: 'Reason',
        it: 'Motivo',
      },
      invalid_points: {
        el: 'Μη έγκυροι Πόντοι',
        en: 'Invalid Points',
        it: 'Punti Non Validi',
      },

      invalid_cashback: {
        el: 'Μη έγκυρο Cashback',
        en: 'Invalid Cashback',
        it: 'Cashback Non Valido',
      },
      requiredField: {
        el: 'Αυτό το πεδίο είναι υποχρεωτικό',
        en: 'This field is required',
        it: 'Questo campo è obbligatorio',
      },
      loyalty: {
        el: 'Πρόγραμμα Πιστότητας',
        en: 'Loyalty Program',
        it: 'Programma di fidelizzazione',
      },
      loadMore: {
        el: 'Φόρτωση περισσότερων...',
        en: 'Loading More...',
        it: 'Per saperne di più...',
      },

      invalid_pointsAmount: {
        el: 'Η τιμή πρέπει να είναι ακέραιος αριθμός (θετικός ή αρνητικός) και διαφορετικός από το 0',
        en: 'The value must be an integer (positive or negative) and not 0',
        it: 'Il valore deve essere un numero intero (positivo o negativo) e diverso da 0',
      },
      invalid_cashbackAmount: {
        el: 'Η τιμή πρέπει να είναι ακέραιος αριθμός (θετικός ή αρνητικός) και διαφορετικός από το 0',
        en: 'The value must be an integer (positive or negative) and not 0',
        it: 'Il valore deve essere un numero intero (positivo o negativo) e diverso da 0',
      },

      invalid_pointsReason: {
        el: 'Παρακαλώ, επιλέξτε μια αιτιολογία για την τροποποίηση πόντων',
        en: 'Please, select a reason for the points adjustment',
        it: 'Si prega di selezionare un motivo per la modifica dei punti',
      },
      invalid_cashbackReason: {
        el: 'Παρακαλώ, επιλέξτε μια αιτιολογία για την τροποποίηση cashback',
        en: 'Please, select a reason for the cashback adjustment',
        it: 'Si prega di selezionare un motivo per la modifica del cashback',
      },
      invalidInput: {
        el: 'Μη έγκυρη τιμή',
        en: 'Invalid value',
        it: 'Input non valido',
      },

      adjust_pointsSuccess: {
        el: 'Η τροποποίηση πόντων ολοκληρώθηκε με επιτυχία.',
        en: 'Points adjustment completed successfully.',
        it: 'La modifica dei punti è stata completata con successo.',
      },
      adjust_cashbackSuccess: {
        el: 'Η τροποποίηση cashback ολοκληρώθηκε με επιτυχία.',
        en: 'Cashback adjustment completed successfully.',
        it: 'La modifica del cashback è stata completata con successo.',
      },
      redeemCouponsTooltip: {
        el: 'Εξαργύρωση κουπονιών',
        en: 'Redeem Coupons',
        it: 'Riscatta i coupon',
      },
      redeemCouponsDialogTitle: {
        el: 'Εξαργύρωση κουπονιών για πελάτη',
        en: 'Redeem Coupons for Customer',
        it: 'Riscatta i coupon per il cliente',
      },
      selectCoupon: {
        el: 'Επιλέξτε κουπόνι',
        en: 'Select Coupon',
        it: 'Seleziona il coupon',
      },
      selectStore: {
        el: 'Επιλέξτε κατάστημα',
        en: 'Select Store',
        it: 'Seleziona negozio',
      },
      city: {
        el: 'Πόλη',
        en: 'City',
        it: 'Città',
      },
      postalCode: {
        el: 'Ταχυδρομικός Κώδικας',
        en: 'Postal Code',
        it: 'Codice Postale',
      },
      floor: {
        el: 'Όροφος',
        en: 'Floor',
        it: 'Piano',
      },
      notes: {
        el: 'Σημειώσεις',
        en: 'Notes',
        it: 'Note',
      },
      bellName: {
        el: 'Όνομα στο κουδούνι',
        en: 'Bell Name',
        it: 'Nome sul campanello',
      },
      quantity: {
        el: 'Ποσότητα',
        en: 'Quantity',
        it: 'Quantità',
      },
      redeemCouponsSuccess: {
        el: 'Η εξαργύρωση κουπονιών ολοκληρώθηκε με επιτυχία.',
        en: 'Coupons redeemed successfully.',
        it: 'I coupon sono stati riscattati con successo.',
      },

      user_points: {
        el: 'Πόντοι χρήστη',
        en: 'User Points',
        it: 'Punti utente',
      },
      user_cashback: {
        el: 'Cashback χρήστη',
        en: 'User Cashback',
        it: 'Cashback utente',
      },

      insufficient_points: {
        el: 'Δεν έχετε αρκετούς πόντους για αυτή την εξαργύρωση.',
        en: 'You do not have enough points for this redemption.',
        it: 'Non hai abbastanza punti per questo riscatto.',
      },
      insufficient_cashback: {
        el: 'Δεν έχετε αρκετό cashback για αυτή την εξαργύρωση.',
        en: 'You do not have enough cashback for this redemption.',
        it: 'Non hai abbastanza cashback per questo riscatto.',
      },

      errorFetching_points: {
        el: 'Σφάλμα κατά την ανάκτηση των πόντων.',
        en: 'Error fetching points.',
        it: 'Errore durante il recupero dei punti.',
      },
      errorFetching_cashback: {
        el: 'Σφάλμα κατά την ανάκτηση του cashback.',
        en: 'Error fetching cashback.',
        it: 'Errore durante il recupero del cashback.',
      },

      notEnough_points: {
        el: 'Δεν έχετε αρκετούς πόντους για αυτή την εξαργύρωση.',
        en: 'You do not have enough points for this redemption.',
        it: 'Non hai abbastanza punti per questo riscatto.',
      },
      notEnough_cashback: {
        el: 'Δεν έχετε αρκετό cashback για αυτή την εξαργύρωση.',
        en: 'You do not have enough cashback for this redemption.',
        it: 'Non hai abbastanza cashback per questo riscatto.',
      },
      pointBalance: {
        el: 'Υπόλοιπο Πόντων',
        en: 'Point Balance',
        it: 'Saldo Punti',
      },

      cashbackBalance: {
        el: 'Υπόλοιπο Cashback',
        en: 'Cashback Balance',
        it: 'Saldo Cashback',
      },

      couponCost: {
        el: 'Κόστος Κουπονιού',
        en: 'Coupon Cost',
        it: 'Costo Coupon',
      },
      missingLoyaltyProgram: {
        el: 'Απουσιάζει πρόγραμμα επιβράβευσης',
        en: 'Missing loyalty program',
        it: 'Programma fedeltà mancante',
      },
      invalidNumberValue: {
        el: 'Μη έγκυρη τιμή: Παρακαλώ, πληκτρολογήστε έναν αριθμό.',
        en: 'Invalid value: Please, type a number.',
        it: 'Valore non valido: Digitare un numero.',
      },
      saved: {
        el: 'Αποθηκεύτηκε',
        en: 'Saved',
        it: 'Salvato',
      },
      notVisible: {
        el: 'Δεν είναι ορατό',
        en: 'Not Visible',
        it: 'Non visibile',
      },
    },
  }),
};
